"use strict";

require("core-js/modules/es.symbol.description.js");
require("core-js/modules/es.weak-map.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/web.dom-collections.iterator.js");
var _react = _interopRequireWildcard(require("react"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
const gaugeChart = {
  position: "relative",
  margin: "20px auto",
  paddingTop: "30px"
};
const sizing = {
  width: "200px",
  height: "auto"
};
const defaultGradientColors = [{
  stop: 0,
  color: '#3CB371'
}, {
  stop: 0.5,
  color: '#FFD700'
}, {
  stop: 1,
  color: '#E33127'
}];
const GaugeChart = _ref => {
  let {
    value,
    min,
    max,
    showHand,
    gradientColors
  } = _ref;
  const canvasRef = (0, _react.useRef)(null);
  const [animationProgress, setAnimationProgress] = (0, _react.useState)(0);
  (0, _react.useEffect)(() => {
    if (typeof value !== 'number' || value > max) {
      console.log("Invalid or missing value");
      return;
    }
    const canvas = canvasRef.current;
    if (!canvas) {
      console.log("Canvas not found");
      return;
    }
    const ctx = canvas.getContext('2d');
    let animationId;
    let startTime;
    const animate = timestamp => {
      if (!startTime) startTime = timestamp;
      const progress = Math.min((timestamp - startTime) / 1000, 1);
      setAnimationProgress(progress);
      drawChart(ctx, progress);
      if (progress < 1) {
        animationId = requestAnimationFrame(animate);
      }
    };
    animationId = requestAnimationFrame(animate);
    return () => {
      cancelAnimationFrame(animationId);
    };
  }, [value, min, max, showHand, gradientColors]);
  const drawChart = (ctx, progress) => {
    if (!canvasRef.current || typeof value !== 'number' || value > max) return;
    const canvas = canvasRef.current;
    ctx.clearRect(0, 0, canvas.width, canvas.height);
    const gradientSegment = ctx.createLinearGradient(20, 100, 180, 100);
    const colors = gradientColors || defaultGradientColors;
    colors.forEach(_ref2 => {
      let {
        stop,
        color
      } = _ref2;
      gradientSegment.addColorStop(stop, color);
    });
    ctx.beginPath();
    ctx.arc(100, 100, 80, Math.PI, 2 * Math.PI);
    ctx.lineWidth = 20;
    ctx.strokeStyle = '#e0e0e0';
    ctx.stroke();
    const percentage = (value - min) / (max - min) * progress;
    const endAngle = Math.PI + percentage * Math.PI;
    ctx.beginPath();
    ctx.arc(100, 100, 80, Math.PI, endAngle);
    ctx.lineWidth = 20;
    ctx.strokeStyle = gradientSegment;
    ctx.stroke();
    if (showHand) {
      const needleAngle = 1.5 * Math.PI + percentage * Math.PI;
      ctx.save();
      ctx.translate(100, 100);
      ctx.rotate(needleAngle);
      ctx.beginPath();
      ctx.moveTo(-5, 0);
      ctx.lineTo(0, -60);
      ctx.lineTo(5, 0);
      ctx.fillStyle = '#333';
      ctx.fill();
      ctx.beginPath();
      ctx.arc(0, 0, 5, 0, 2 * Math.PI);
      ctx.fillStyle = '#333';
      ctx.fill();
      ctx.restore();
    }
    const animatedValue = Math.round(value * progress);
    ctx.font = 'bold 24px Arial';
    ctx.fillStyle = '#333';
    ctx.textAlign = 'center';
    ctx.textBaseline = 'middle';
    ctx.fillText(animatedValue, 100, 130);
    ctx.font = 'bold 16px Arial';
    ctx.fillStyle = '#666';
    ctx.textAlign = 'center';
    ctx.fillText(min, 20, 120);
    ctx.fillText(max, 180, 120);
  };
  if (typeof value !== 'number') {
    return /*#__PURE__*/_react.default.createElement("div", null, "The data entered is not a number. Please Enter a \"Number\"");
  }
  if (value > max) {
    return /*#__PURE__*/_react.default.createElement("div", null, "Please Enter a number lesser than max value");
  }
  if (value < min) {
    return /*#__PURE__*/_react.default.createElement("div", null, "Please Enter a number greater than min value");
  }
  return /*#__PURE__*/_react.default.createElement("div", {
    style: _objectSpread(_objectSpread({}, gaugeChart), sizing)
  }, /*#__PURE__*/_react.default.createElement("canvas", {
    ref: canvasRef,
    width: "200",
    height: "200"
  }));
};
var _default = exports.default = GaugeChart;